import type { FaireProductEntity } from "../../entity_types/product";

export const p_v45pjyjz46: FaireProductEntity = {
  token: "p_v45pjyjz46",
  type: "product",
  name: "Moments - Mothers Day Scented Candles",
  brandToken: "b_cn5gjabht6",
  brandName: "Soy Harvest Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/d174ff959f7bd48349f718f73e32d238669b874260d3e360806668774febb802.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43829abd2ef6ff6223254ec422603a62a22ef8341bb82e1538c9a8f3e712bffe.png",
    "https://cdn.faire.com/fastly/6d677897899460f110098323cadbcee57e16ad0d9e55138d49c76817d4d4ef91.png",
    "https://cdn.faire.com/fastly/7c5e4c1d7fbae24cd2656cf7e68da75fd9f9ef0e3b888cf47f81659800fe7d89.png",
  ],
  priceDollars: 50,
  description:
    "Case total: 12 Candles \n\n4 Candles - Coolest Mom\n\n4- Candles - I Love You Mom\n\n4- Candles - Heart of the Family\n\nBurn time is Up to 24 hours with a glass lid to stay dust free and seal in the amazing scent. \n\nEach Candles is: 3 oz of beautifully scented all natural soy wax with a cotton wick. Phthalate and Paraben Free. \n\nAll Candles are scented the with the same fragrance. \n\nDescription: Blending the serene notes of lotus water with the vibrant sweetness of red berries and the gentle whisper of willow, it creates an aroma that's both uplifting and calming.\n",
  tags: [],
  msrpDollars: 100,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:46.844Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
